"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useActivityKeys;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useActivityKeys() {
  return (0, _useContext.default)().activityKeysState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VBY3Rpdml0eUtleXMiLCJ1c2VBY3Rpdml0eUtleWVyQ29udGV4dCIsImFjdGl2aXR5S2V5c1N0YXRlIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcHJvdmlkZXJzL0FjdGl2aXR5S2V5ZXIvdXNlQWN0aXZpdHlLZXlzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VBY3Rpdml0eUtleWVyQ29udGV4dCBmcm9tICcuL3ByaXZhdGUvdXNlQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUFjdGl2aXR5S2V5cygpOiByZWFkb25seSBbcmVhZG9ubHkgc3RyaW5nW11dIHtcbiAgcmV0dXJuIHVzZUFjdGl2aXR5S2V5ZXJDb250ZXh0KCkuYWN0aXZpdHlLZXlzU3RhdGU7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLGVBQVQsR0FBeUQ7RUFDdEUsT0FBTyxJQUFBQyxtQkFBQSxJQUEwQkMsaUJBQWpDO0FBQ0QifQ==